import { render, staticRenderFns } from "./WidthHeightField.vue?vue&type=template&id=37615b36&scoped=true"
import script from "./WidthHeightField.vue?vue&type=script&lang=ts"
export * from "./WidthHeightField.vue?vue&type=script&lang=ts"
import style0 from "./WidthHeightField.vue?vue&type=style&index=0&id=37615b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37615b36",
  null
  
)

export default component.exports